/**
 * Created by wang chong on 2017/9/13.
 */

import maple from 'maple';

/**
 * 用途，天狗App使用session cookie，web端使用sessionStorage，最大限度的保持“会话”的有效性
 * Why？
 *      为什么天狗不使用sessionStorage？
 *      因为天狗App内的web页中的会话不一定是连续的，所以sessionStorage中的值是不可信的。
 *      为什么web端不用session cookie？
 *      现在的web浏览器即使关掉页面，session cookie也会保留，只有在关掉浏览器进程后才能删除掉session cookie
 */
class tgSession {
    constructor(){
        this.isApp = maple.cookie('global') === 'ios' || maple.cookie('global') === 'android';
    }
    setItem(){
        if(this.isApp){
            return maple.cookie.apply(maple, arguments);
        }else{
            return sessionStorage.setItem.apply(sessionStorage, arguments);
        }
    }
    getItem(){
        if(this.isApp){
            return maple.cookie.apply(maple, arguments);
        }else{
            return sessionStorage.getItem.apply(sessionStorage, arguments);
        }
        
    }
    removeItem(){
        if(this.isApp){
            return maple.cookie.remove.apply(maple, arguments);
        }else{
            return sessionStorage.removeItem.apply(sessionStorage, arguments);
        }
    }
}

export default new tgSession();